import React from 'react';
import { Check, X, RefreshCw, Unlink } from 'lucide-react';
import CustomSelect from '../components/CustomSelect';
import ScreenHeader from '../components/ScreenHeader';
import { requestGoogleAccess } from '../services/calendarService';
import { PREP_TIME_OPTIONS } from '../constants/options';

export default function SettingsScreen({
  googleCalConnected,
  googleAccessToken,
  isSyncing, syncError, setSyncError,
  fetchAndSyncGoogleEvents,
  disconnectGoogle,
  GOOGLE_CLIENT_ID,
  setCurrentScreen,
  setPendingCalendar, setShowCalPermissionModal,
}) {
  return (
    <div className="h-full flex flex-col">
      <ScreenHeader title="Settings" onBack={() => setCurrentScreen('home')} />

      {/* Settings Content */}
      <div className="flex-1 overflow-auto p-4 space-y-4">
        {/* Calendar Integration */}
        <div>
          <h3 className="font-semibold text-gray-900 mb-3">My Calendar</h3>
          <div className="space-y-2">
            <div className="flex items-center justify-between p-3 bg-gray-50 rounded-lg">
              <span className="text-sm">Google Calendar</span>
              {googleCalConnected ? (
                <div className="flex items-center gap-2">
                  <span className="flex items-center gap-1 text-green-600 text-sm font-medium">
                    <Check size={16} /> Connected
                  </span>
                  <button
                    onClick={() => googleAccessToken && fetchAndSyncGoogleEvents(googleAccessToken)}
                    disabled={isSyncing}
                    className="p-1 text-blue-600 hover:bg-blue-50 rounded"
                    title="Sync"
                  >
                    <RefreshCw size={14} className={isSyncing ? 'animate-spin' : ''} />
                  </button>
                  <button
                    onClick={disconnectGoogle}
                    className="p-1 text-red-500 hover:bg-red-50 rounded"
                    title="Disconnect"
                  >
                    <Unlink size={14} />
                  </button>
                </div>
              ) : (
                <button
                  onClick={() => {
                    if (GOOGLE_CLIENT_ID && GOOGLE_CLIENT_ID !== 'your-client-id-here.apps.googleusercontent.com') {
                      requestGoogleAccess();
                    } else {
                      setPendingCalendar('google');
                      setShowCalPermissionModal(true);
                    }
                  }}
                  className="px-3 py-1 bg-blue-500 text-white text-sm font-medium rounded-lg"
                >
                  Add
                </button>
              )}
            </div>
          </div>
          {syncError && (
            <div className="mt-2 p-2 bg-red-50 border border-red-200 rounded-lg text-xs text-red-600 flex items-center justify-between">
              <span>{syncError}</span>
              <button onClick={() => setSyncError(null)} className="ml-2 p-0.5 hover:bg-red-100 rounded">
                <X size={12} />
              </button>
            </div>
          )}
        </div>

        {/* Default Prep Time */}
        <div>
          <h3 className="font-semibold text-gray-900 mb-3">Default Prep Time</h3>
          <CustomSelect options={PREP_TIME_OPTIONS} defaultValue={0} />
        </div>

        {/* About */}
        <div className="pt-4 border-t-2 border-gray-200">
          <button
            onClick={() => window.open('/privacy', '_blank')}
            className="w-full text-left p-3 hover:bg-gray-50 rounded-lg text-sm text-gray-600"
          >
            Privacy Policy
          </button>
          <button
            onClick={() => window.open('/terms', '_blank')}
            className="w-full text-left p-3 hover:bg-gray-50 rounded-lg text-sm text-gray-600"
          >
            Terms of Service
          </button>
          <button className="w-full text-left p-3 hover:bg-gray-50 rounded-lg text-sm text-gray-600">
            Help & Support
          </button>
          <button className="w-full text-left p-3 hover:bg-gray-50 rounded-lg text-sm text-red-600 font-medium">
            Sign Out
          </button>
        </div>
      </div>
    </div>
  );
}
